import React from 'react';

import { defaultDropAnimationSideEffects, DragOverlay } from '@dnd-kit/core';
import type { DropAnimation } from '@dnd-kit/core';

import { WorkflowCard } from './workflow-card/WorkflowCard';
import type { WorkflowCardWorkflow } from './workflow-card/WorkflowCard';

/**
 * Drop animation that fades the source item while the overlay is visible,
 * providing clear visual feedback during the drop transition.
 */
const dropAnimation: DropAnimation = {
  duration: 150,
  easing: 'ease-out',
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: { opacity: '0.4' },
    },
  }),
};

interface WorkflowCardOverlayProps {
  activeWorkflow: WorkflowCardWorkflow | null;
}

/**
 * Renders the drag overlay for a workflow card during drag operations.
 * Shows a semi-transparent copy of the card that follows the cursor.
 */
export function WorkflowCardOverlay({ activeWorkflow }: WorkflowCardOverlayProps): JSX.Element {
  if (!activeWorkflow) return <DragOverlay dropAnimation={dropAnimation}>{null}</DragOverlay>;

  return (
    <DragOverlay dropAnimation={dropAnimation}>
      <WorkflowCard
        style={{ boxShadow: '0 8px 24px rgba(0,0,0,0.15)', cursor: 'grabbing' }}
        workflow={activeWorkflow}
      />
    </DragOverlay>
  );
}
